import { SharedContextProps } from "@lib/types";

import { FormattedMessage } from "react-intl";
import { FaBtc } from "react-icons/fa";
import { PiGitPullRequestLight } from "react-icons/pi";
import { MdHistory } from "react-icons/md";
import { AppTabProps } from "@lib/components/AppComponents/AppTabs";

import {
  SharedWalletAddressSendByteList,
  SharedSendBytePaymentList,
  SharedSendBytePaymentRequestList,
} from "@app/shared";

export const getCustomerLeadDetailTabs =
  (): AppTabProps<SharedContextProps>[] => [
    {
      key: "transactionHistory",
      Title: <FormattedMessage id={"customer.tabs.sendBytePayments"} />,
      Icon: <MdHistory />,
      Component: SharedSendBytePaymentList,
    },
    {
      key: "blockchainScanRequest",
      Title: <FormattedMessage id={"customer.tabs.sendBytePaymentRequests"} />,
      Icon: <PiGitPullRequestLight />,
      Component: SharedSendBytePaymentRequestList,
    },
    {
      key: "walletAccounts",
      Title: <FormattedMessage id={"customer.tabs.walletAccountsSendByte"} />,
      Icon: <FaBtc />,
      Component: SharedWalletAddressSendByteList,
    },
  ];
